var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application-customer-history animated fadeIn"},[_c('customer-history',{staticClass:"mt-4",attrs:{"store-module":"applications","history-state":"applicationCustomerHistory"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }